import { Type } from "class-transformer";
import { SMSHistoryOutDTO } from "./sms-history.out.dto";

export class SMSHistoryPaginatedOutDTO {
  @Type(() => SMSHistoryOutDTO)
  history!: SMSHistoryOutDTO[];

  total!: number;
}
